import Group from "@/models/Group";
import Model from "@/models/Model";
import User from "@/models/User";
import UserClass from "@/models/UserClass";
import Homework from "@/models/Homework";

export default class Account extends Model {
    resource() {
        return "accounts";
    }

    classes() {
        return this.hasMany(UserClass);
    }

    groups() {
        return this.hasMany(Group);
    }

    users() {
        return this.hasMany(User);
    }

    homework() {
        return this.hasMany(Homework);
    }
}
